import React from "react"
import TableRowColumn from "material-ui/Table/TableRowColumn"
import TimecardPunchControl from "./TimecardPunchControl"
import { IPunchSetDocument, ISuspensePunchData, ITimecardDay, ITimecardEmployee, IJobStatusData, ICommentData } from "../../models"
import EmployeeTimecardTablePSCell from "./EmployeeTimecardTablePSCell"
interface IProps {
    fullPunchSets: IPunchSetDocument[]
    day: ITimecardDay
    hierarchyItemId: string
    jobId: string
    phaseId: string
    positionId: string
    timecardLocked: boolean
    readonly: boolean
    user: ITimecardEmployee
    suspensePunchData: ISuspensePunchData
    jobStatusData: IJobStatusData[]
    commentData: ICommentData[]
    addPunch(timecardDay: ITimecardDay, hierarchyItemId: string, positionId: string, payClassId: string, payTypeId: string, shiftId: string, breakId: string, mobileBreakId: string, jobId: string, phaseId: string, equipmentId: string, isPunchIn: boolean, pairedPunchId: string): void
    onConfirmDelete(punchId: string): void
    onTimeChange(punchId: string, dateTime: Date | string, errorCb: () => void): void
    reloadTimecard(msg: string): void
    handleApprovePunchSet(status: "unapprove" | "approve", punchSet: IPunchSetDocument): void

    //we need to select hierarchy based on employee punch permission, not logged in user punch permission (when the user has more punch rights than the admin)
    //it's possible when full timecard, for example, employee->timecard and payroll->timecard
    //timecards page is not full timecard in the case filter by punch level
    isFullTimecard?: boolean
    allowPriorPeriodAdjust: boolean

    virtualTimecard: boolean

    priorPeriodAdjustMode: boolean
    originalTimecard: boolean
    showTimecardDetails: boolean

}

const getChildPunchSets = (fullPunchSets, punchSetId): IPunchSetDocument[] => {
    const childPunchSets = fullPunchSets.filter(i => i.MasterPunchSetId === punchSetId)
    return childPunchSets
}

const EmployeeTimecardTableDay: React.SFC<IProps> = (props: IProps) => {
    const styles = {
        unlockCol: { textAlign: "left", verticalAlign: "top" },
        lockCol: { textAlign: "left", verticalAlign: "top", backgroundColor: "#EFEFEF" }
    }

    return (
        <TableRowColumn
            className="EmployeeTimecardTableRowColumn"
            style={{ ...(props.timecardLocked ? styles.lockCol : styles.unlockCol), paddingLeft: 0, paddingRight: 0 }}
        >
            <div style={{ paddingBottom: 10 }} onClick={(e) => e.stopPropagation()}>
                {props.day.PunchSets.filter(timecardPS =>
                    !props.fullPunchSets.find(i => i.Id === timecardPS.Id).Calculated &&
                    props.fullPunchSets.find(i => i.Id === timecardPS.Id).MasterPunchSetId === null
                ).map((timecardPS, index) =>
                    <EmployeeTimecardTablePSCell
                        key={timecardPS.Id}
                        day={props.day}
                        timecardLocked={props.timecardLocked}
                        readonly={props.readonly}
                        punchSet={props.fullPunchSets.find(i => i.Id === timecardPS.Id)}
                        childPunchSets={getChildPunchSets(props.fullPunchSets, timecardPS.Id)}
                        user={props.user}
                        addPunch={props.addPunch}
                        onConfirmDelete={props.onConfirmDelete}
                        onTimeChange={props.onTimeChange}
                        reloadTimecard={props.reloadTimecard}
                        handleApprovePunchSet={props.handleApprovePunchSet}
                        isFullTimecard={props.isFullTimecard}
                        allowPriorPeriodAdjust={props.allowPriorPeriodAdjust}
                        suspensePunchData={props.suspensePunchData}
                        jobStatusData={props.jobStatusData}
                        commentData={props.commentData}
                        virtualTimecard={props.virtualTimecard}
                        priorPeriodAdjustMode={props.priorPeriodAdjustMode}
                        originalTimecard={props.originalTimecard}
                        showTimecardDetails={props.showTimecardDetails}
                        fullPunchSets={props.fullPunchSets}
                    />
                )}
                {!(props.timecardLocked || props.readonly) &&
                    <div style={{ marginLeft: 25 }}>
                        <TimecardPunchControl
                            hintText="+ ADD"
                            value={null}
                            onAddPunch={() => props.addPunch(props.day, props.hierarchyItemId, props.positionId, null, null, null, null, null, props.jobId, props.phaseId, null, true, null)}
                        />
                    </div>
                }
            </div>
        </TableRowColumn>
    )
}

export default EmployeeTimecardTableDay
